const ENV = {
  API_BACKEND_URL: import.meta.env.VITE_API_BACKEND_URL as string,
  WS_URL: import.meta.env.VITE_WS_URL as string,
  WELCOMEBACK_BLOCK_ID: import.meta.env.VITE_WELCOMEBACK_BLOCK_ID as string,
  CHESTBOX_BLOCK_ID: import.meta.env.VITE_CHESTBOX_BLOCK_ID as string,
  RESOURCE_BOOST_BLOCK_ID: import.meta.env
    .VITE_RESOURCE_BOOST_BLOCK_ID as string,
  MATERIAL_BOOST_BLOCK_ID: import.meta.env
    .VITE_MATERIAL_BOOST_BLOCK_ID as string,
  GOODS_BOOST_BLOCK_ID: import.meta.env.VITE_GOODS_BOOST_BLOCK_ID as string,
  IS_PROD: import.meta.env.PROD,
  IS_DEV: import.meta.env.DEV,
  TELEGRAM_BOT_NAME: import.meta.env.VITE_TELEGRAM_BOT_NAME as string,
  TELEGRAM_ANALYTICS_NAME: import.meta.env
    .VITE_TELEGRAM_ANALYTICS_NAME as string,
  TELEGRAM_ANALYTICS_TOKEN: import.meta.env
    .VITE_TELEGRAM_ANALYTICS_TOKEN as string,
  FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY as string,
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  FIREBASE_STORAGE_BUCKET: import.meta.env
    .VITE_FIREBASE_STORAGE_BUCKET as string,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env
    .VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID as string,
  FIREBASE_MEASUREMENT_ID: import.meta.env
    .VITE_FIREBASE_MEASUREMENT_ID as string,
  NODE_ENV: import.meta.env.VITE_NODE_ENV as string,
  MIN_LEVEL_FOR_HELPICON: import.meta.env.VITE_MIN_LEVEL_FOR_HELPICON as number,
  ADSGRAM_DAILY_BONUS_BLOCK_ID: import.meta.env
    .VITE_ADSGRAM_DAILY_BONUS_BLOCK_ID as string,
  ADSGRAM_BOX_MARKET_BLOCK_ID: import.meta.env
    .VITE_ADSGRAM_BOX_MARKET_BLOCK_ID as string,
  TONCONNECT_MANIFEST_URL: import.meta.env
    .VITE_TONCONNECT_MANIFEST_URL as string,
  BUY_STARS_URL: import.meta.env.VITE_BUY_STARS_URL as string,
  MONETAG_ZONE_ID: import.meta.env.VITE_MONETAG_ZONE_ID as string,
  AUTH_ZERO_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN as string,
  AUTH_ZERO_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID as string,
  AUTH_ZERO_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE as string,
  MIN_USDT_TO_WITHDRAW: 15 as number,
  HOLIDAY: import.meta.env.VITE_HOLIDAY as string,
  ADEXIUM_WELCOMEBACK_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_WELCOMEBACK_BLOCK_ID as string,
  ADEXIUM_CHESTBOX_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_CHESTBOX_BLOCK_ID as string,
  ADEXIUM_RESOURCE_BOOST_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_RESOURCE_BOOST_BLOCK_ID as string,
  ADEXIUM_MATERIAL_BOOST_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_MATERIAL_BOOST_BLOCK_ID as string,
  ADEXIUM_GOODS_BOOST_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_GOODS_BOOST_BLOCK_ID as string,
  ADEXIUM_DAILY_BONUS_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_DAILY_BONUS_BLOCK_ID as string,
  ADEXIUM_BOX_MARKET_BLOCK_ID: import.meta.env
    .VITE_ADEXIUM_BOX_MARKET_BLOCK_ID as string,
  LOTTERY_ANIMATE_DURATION: import.meta.env
    .VITE_LOTTERY_ANIMATE_DURATION as string,
  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY as string,
  POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST as string,
} as const;

export { ENV };
